/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaPictureIcon16Light = forwardRef('MediaPictureIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M8.228 7.616a.75.75 0 0 1 1.06 0l1.76 1.76a.5.5 0 1 0 .707-.707l-1.76-1.76a1.75 1.75 0 0 0-2.474 0l-3.875 3.874a.5.5 0 1 0 .708.707l3.874-3.874Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4Zm3-2a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Z" })));
});
